<template>
  <section
    id="hero"
    class="ml-6 mr-6"
  >
    <!--
    :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.JPG`)"
        :aspect-ratio="4/3"
    -->
    <v-container class="grey lighten-5">
      <span class="trace">PondVillage.vue</span>
      <br>
      <h1>NITRATE and HOME VALUE</h1>
      <h3>How Increases in Nitrate Levels Can Affect Your Home's Value</h3>
      <v-row>
        <v-col
          cols="6"
        >
          <p>
            Water quality degradation resulting from nitrate pollution has been shown to impact single-family home sale prices negatively.
          </p>
          <p>
            This calculator is provided to apply the model from the Cape Cod Commission to your home value and nitrate levels.  If you don't know your nitrate levels, you can test for the current value, and then retest a year later.  Or you can estimate the values and see what the result might be.
          </p>
          <v-card>
            <v-subheader
              class="pl-2 pz-3 grey--text"
            >
              Enter your information:
            </v-subheader>

            <v-text-field
              v-model="currentValue"
              class="px-2 pz-3"
              label="Your Home Value today"
              prefix="$"
            />

            <v-text-field
              v-model="recentNitrate"
              class="px-2 pz-3"
              label="Most Recent Nitrate Test Value"
              suffix="mg/L"
              type="number"
              step="0.1"
            />

            <v-text-field
              v-model="previousNitrate"
              class="px-2 pz-3"
              label="Previous Nitrate Test Value"
              suffix="mg/L"
              type="number"
              step="0.1"
            />
          </v-card>
          <!--
          append-outer-icon="mdi-up"
          v-model.number="previousNitrate"

          {{ nitrateIncreasePercent }}

          <v-text-field
            label="What-If Nitrate Levels Increase by"
            v-model="nitrateIncreasePercent"
            suffix="%"
          ></v-text-field>

          <v-col cols="12">
          </v-col>

          -->
          <div class="pt-6 px-3">
            <v-subheader class="pl-0 pb-14">
              <span v-if="nitrateIncreasePercent>=0">Nitrate&nbsp; Increased {{ nitrateIncreasePercent }}</span>
              <span v-if="nitrateIncreasePercent<0">Nitrate&nbsp; Decreased {{ -nitrateIncreasePercent }}</span>%
            </v-subheader>
            <v-slider
              v-if="nitrateIncreasePercent>=0"
              v-model="nitrateIncreasePercent"
              thumb-label="always"
              :color="ex1.color"
              readonly
            />
          </div>
          <!--
          <v-text-field
            label="Your Home Value tomorrow"
            outlined
            v-model="adjustedValueCommas"
            prefix="$"
            readonly
          ></v-text-field>

          <v-subheader class="pl-0 pb-14 grey--text">Statistical Range of Value: from ${{ adjustedValueLow }} to ${{ adjustedValueHigh }}</v-subheader>
          -->

          <v-card>
            <div class="pl-1 pt-3 ">
              Your Home Value tomorrow = ${{ adjustedValueCommas }}
            </div>
            <v-subheader
              class="pl-2 pz-3 grey--text"
            >
              Statistical Range of Value: from ${{ adjustedValueLow }} to ${{ adjustedValueHigh }}
            </v-subheader>
          </v-card>

          <div v-if="lostValue<=0">
            <!--
            <v-text-field
              label="Lost Home Value "
              outlined
              v-model="lostValueCommas"
              prefix="$"
              readonly
            ></v-text-field>
            <v-subheader class="pl-1 pz-14 grey--text">Statistical Range of Loss: from ${{ lostValueLow }} to ${{ lostValueHigh }}</v-subheader>
            -->

            <v-card>
              <div class="pl-1 pt-3 red--text">
                Lost Home Value = ${{ lostValueCommas }}
              </div>
              <v-subheader class="pl-2 pz-3 grey--text">
                Statistical Range of Loss: from ${{ lostValueLow }} to ${{ lostValueHigh }}
              </v-subheader>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <div>
        <p>
          <br><br>
          <b>
            Cape Cod Area Wide Water Quality Management Plan Update
          </b>
          <br>
          June 2015 page S-ii
          <br>
          Prepared by the Cape Cod Commission
        </p>
        <p>
          Case Study: Three Bays
          <br>
          THREE BAYS: ESTIMATED IMPACT OF
          NITROGEN ON PROPERTY VALUES
        </p>
        <p>
          A study evaluating home prices in the Three Bays area
          in the Town of Barnstable was conducted to test the
          hypothesis that water quality degradation resulting
          from nitrogen pollution impacts single-family home
          sale prices negatively. Single-family properties within
          1,000m or about 10 minutes walking distance from
          the waterfront comprise the study area. The model
          estimates the impact of water quality – nitrogen
          levels – on home sale prices, controlling for property
          attributes, macroeconomic influences, proximity to
          public beaches, distance to water. The time period of
          the analysis is between 2005 and 2013.
        </p>
        <p>
          Initial findings demonstrate a 1% increase in nitrogen
          is associated with a decrease in single-family home
          sale prices in the range of 0.407% to 0.807% (average
          0.61%), with a 95% confidence level. During the
          study period the water quality in Three Bays degraded
          by 15.8%. The above range of estimated decrease
          translates into a noticeable fiscal impact on the
          community, both in terms of decrease in sale price
          and consequent impact on the assessed value.
        </p>
        <p>
          For example, if the discharge of nitrogen into
          Three Bays waters was lessened resulting in a 3%
          decrease in total nitrogen level, average singlefamily home sale prices in the study area would
          have been $16,774 to $32,957 higher than in 2013.
          That translates into potential sale value loss (and
          consequent assessed value loss) in the range of
          $49 to $86 million in the study site alone (1,000m
          or ten-minute walking distance to the waterfront).
          No action in 2015 will bring additional loss of home
          value to Cape Cod due to degrading water quality
          from nitrogen.
        </p>
        <p>
          Cape Cod’s environment is linked directly to its
          economy. The nitrogen problem is a significant
          threat to both. Continued degradation of the coastal
          resources on Cape Cod will negatively impact the
          seasonal and year-round economies, affecting
          property values for year-round residents and second
          homeowners, and shifting property tax burdens
          away from higher value seasonally occupied coastal
          properties on to middle class year-round residents.
        </p>

        <p>
          <a
            href="
              https://www.capecodcommission.org/resource-library/file/?url=/dept/commission/team/208/208%20Final/Cape_Cod_Area_Wide_Water_Quality_Management_Plan_Update_June_15_2015.pdf"
            target="_blank"
          >Full Report pdf
          </a>
        </p>
        <div v-if="1==0">
          Your Home Value today is     ${{ currentValue }} <br>
          If Nitrate Levels increased by        {{ nitrateIncreasePercent*100 }}% tomorrow<br>
          Your Estimated Home Value tomorrow will be  ${{ adjustedValue}}
          <br>
        </div>
        <hr>
        <div class="text-caption pl-5 py-5">
          These estimates above are per the model from the Cape Cod Commission:<br>
          <div class="text-caption pl-5">
            y<sub>1</sub> = y<sub>0</sub> * (1 - c*&Delta;N/100), where<br>
            <div class="text-caption pl-5">
              y<sub>1</sub> = estimated home value,<br>
              y<sub>0</sub> = current home value,<br>
              &Delta;N = change in nitrate levels in percents,<br>
              c = model parameter (decrease in value per increase in nitrate level) = {{ valuePerNitrateFactor }} mean
              <br>95% confidence range of c = [0.407 to 0.807]
            </div>
          </div>
        </div>
        <hr>
      </div>
        <br><br><br><br><br>

      <v-row v-if="1==0">
        <v-col
          md="10"
          offset-md="1"
        >
          <v-btn
            small
            class="mr-0 small"
            @click="wpClick"
          >
            Back to Water Protectors<span class="hidden-md-and-down">...</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="1==0">
        <v-col
          md="10"
          offset-md="1"
        >
          <div v-if="youTube">
            <hr>
            <p class="mt-2">
              * The Silent Spring Institute of Newton has been analyzing water from Cape Cod’s private wells for over 20 years. Where they differ from standard EPA guidelines for safe water is that, for example, they consider that when testing for a nitrates, anything below 10 ppm (10 mg/liter) is considered safe, while the Silent Spring maintains that nitrate levels should not exceed 1 ppm. Their water analyses show that even at 1 ppm they are finding known carcinogenic substances in the water such as glyphosate, PFOS, PFOA, MTBE, just to name a few!  Both water specialists and filter company Culligan, and the Silent Spring Institute have found contaminants in water tested upon request from Truro residents.
            </p>
            <p class="mt-2">
              **In an article, titled <em>Cape Cod is a hot spot for certain types of cancers</em>, posted on 28 November, 2017, journalist Joyce R.  Young reports, “For the last 20 years, the Silent Spring Institute of Newton has been investigating one of Cape Cod’s dark sides: high rates of breast cancer.  At its annual Cape Cod update presentation in October 2017, the institute shared more research data on what are known as contaminants of emerging concern emanating from the Cape’s septic systems and cesspools in relation to the high breast cancer rates.”
            </p>

          </div>
        </v-col>
      </v-row>

      <v-row v-if="1==0">
        <v-col
          md="10"
          offset-md="1"
        >
          <v-btn
            small
            class="mr-0 small"
            @click="wpClick"
          >
            Back to Water Protectors<span class="hidden-md-and-down">...</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'PondVillageEquity',

    components: {
      // ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    data: () => ({
      // maxW: 800,
      youTube: true,
      currentValue: 475000,
      nitrateIncreasePercentDefault: 15,
      valuePerNitrateFactor: 0.61,
      valuePerLow: 0.407,
      valuePerHigh: 0.807,
      recentNitrate: 2.3,
      previousNitrate: 2.0,
      calculate: false,
      ex1: { label: 'color', val: 25, color: 'red' },
    }),

    computed: {
      adjustedValue () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerNitrateFactor)
        return Math.round(x)
      },
      adjustedValueLow () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerLow)
        return Math.round(x)
      },
      adjustedValueHigh () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerHigh)
        return Math.round(x)
      },
      adjustedValueCommas () {
        return this.adjustedValue.toLocaleString()
        // return Number(parseFloat(this.adjustedValue.toFixed(0).toLocaleString('en', { minimumFractionDigits: 0 })))
      },

      lostValue () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerNitrateFactor)
        return Math.round(x)
      },
      lostValueLow () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerLow)
        return Math.round(x)
      },
      lostValueHigh () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerHigh)
        return Math.round(x)
      },
      lostValueCommas () {
        return this.lostValue.toLocaleString()
      },

      nitrateIncreasePercent () {
        if (this.recentNitrate > 0 && this.previousNitrate > 0) {
          return Math.round(100 * (this.recentNitrate / this.previousNitrate - 1))
        } else return this.nitrateIncreasePercentDefault
      },

    },

    methods: {
      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },
      sayMe: function (arg) {
        console.log(arg)
        // alert('ProjectCard.vue:' + this.graphic)
      },

    },

  }
</script>

<style scoped>
h1 {
  color: dodgerblue
}
</style>
